// extracted by mini-css-extract-plugin
export default {"root":"IconHome_root__2utty"};